import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Outlet, useParams } from 'react-router-dom';
import { KoTitle, KoAvatar, KoButton, KoAffix, KoDescription, KoTag, KoLoader, KoDropdown, KoText, KoModal, KoForm, KoToast } from 'packages';
import KoIcon from '@kwapio/icons';
import { useDispatch } from 'react-redux';
import {HepldeskAPI} from "./helpdesk.service";

import styles from './helpdesk.module.scss';
import { getSprints } from "shared/store/sprintSlice";
import WorkspaceCurd from "pages/workspace/workspacecurd";
import { getCurrentAssignees } from "shared/store/currentAssigneesSlice";
import { workspaceAPI } from "pages/workspace/workspace.service";
import { formatDate } from "shared/utils";

import ITSupportCurd from "./curd/curd";

function HepldeskModule() {
  let { workspaceId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const seletedDate = searchParams.get('date');
  const seletedSprint = searchParams.get('sprint');
  const [isOpen, setModal] = useState();
  const [isOpenTicketCreate, setModalTicketCreate] = useState();
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const [profile, setProfile] = useState(currentAssignees['data'] || []);
  const [sprints, setSprints] = useState();
  const [workspace, setWorkspaceObject] = useState();
  const [loading, setLoading] = useState(false);
  const [shareSprint, setShareSprint] = useState();
  const [filter, setFilter] = useState('Last 7 days');
  const [form] = KoForm.useForm();
  let navigate = useNavigate();
  useEffect(() => {
    if (workspaceId) {
      getWorkspaceById(workspaceId);
      dispatch(getCurrentAssignees(workspaceId));
    }
    dispatch(getSprints({ workspaceId: workspaceId }));
  }, [workspaceId]);

  useEffect(() => {
    getActiveSprints();
  }, []);

  useEffect(() => {
    setProfile(currentAssignees['data'] || []);
  }, [currentAssignees]);

  const getWorkspaceById = (workspaceId) => {
    setLoading(true);
    workspaceAPI.getWorkspaceById(workspaceId).then(
      (data) => {
        setLoading(false);
        setWorkspaceObject(data['project']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  

  const isDashboardUrl = window.location.pathname.split('/').pop();
  const getActiveSprints = () => {
    setSprints();
    HepldeskAPI.getActiveSprints(workspaceId).then(
      (data) => {
        let sprintsAll = [{name:'All Sprints', sprintId:'all'}, ...data?.sprints];
        setSprints(sprintsAll);
        let findObj = sprintsAll?.find((obj) => obj?.sprintId === seletedSprint);
        setShareSprint(findObj);
      },
      (err) => {
      }
    );
  };

  const handleMenuClickIssue = ({ key }) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('sprint', key);
    setSearchParams(newParams);
    let findObj = sprints?.find((obj) => obj?.sprintId === key);
    setShareSprint(findObj);
  };

  const shareSprintId = shareSprint && shareSprint?.sprintId;


  const dateRangeOptions = [
    {
      key: "today",
      label: "Today"
    },
    {
      key: "yesterday",
      label: "Yesterday"
    },
    {
      key: "currentWeek",
      label: "This Week"
    },
    {
      key: "lastWeek",
      label: "Last Week"
    },
    {
      key: "last7Days",
      label: "Last 7 Days"
    },
    {
      key: "currentMonth",
      label: "This Month"
    },
    {
      key: "lastMonth",
      label: "Last Month"
    },
    {
      key: "last3Months",
      label: "Last 3 Months"
    },
    {
      key: "last6Months",
      label: "Last 6 Months"
    },
    {
      key: "currentYear",
      label: "This Year"
    },
    {
      key: "lastYear",
      label: "Last Year"
    }
  ];

  useEffect(() => {
    if (seletedDate) {
      let item = dateRangeOptions.find((item) => item.key === seletedDate);
      setFilter(item?.label);
    }
  }, [seletedDate]);


  useEffect(() => {
    if(seletedSprint){
      let findObj = sprints?.find((obj) => obj?.sprintId === seletedSprint);
      setShareSprint(findObj);
    }
  }, [seletedSprint]);


  const getDashboardData = ({ key }) => {
    let item = dateRangeOptions.find((item) => item.key === key);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('date', key);
    setSearchParams(newParams);
    setFilter(item?.label);
  };


  const handleFinish = (values => {
    setLoading(true);
    console.log('helpdesk tickets');
    HepldeskAPI.createOrUpdateIssues(values, null, workspaceId).then(
      (data) => {
        setLoading(false);
        form.resetFields();
        KoToast.success(`Ticket created successfully ${data?.ticketId}`);
        setModalTicketCreate(false);
        if(isDashboardUrl === 'tickets'){
          navigate(`/workspace/${workspaceId}/helpdesk/tickets`);
        }
      },
      (err) => {
        setLoading(false);
        KoToast.error(err?.error);
      }
    );
  });

  return <>
    {loading && <KoLoader/>}
    <div className={`${styles.wrapper}`}>
      <KoAffix top={50}>
        <div className={styles.dashboardHeader}>
          <div className={styles.headerWrapper}>
            <div className={styles.header}>
              <KoTitle ellipsis={true} text={workspace?.name} level={1} />
              <KoButton className={styles.orgclass} label={workspace?.customerProfile?.companyName} type='text' icon={<KoIcon name={'OrgOutlined'} width={18} height={18} />} />
              <KoTag ellipsis={true} iscount={false} value={'On Track '} color='color-1' radius={false} custom={true} />
              <KoButton label={`Planned End: ${formatDate(workspace?.idealStartDate, 'DD-MMM-YYYY')}; Current ETA: ${formatDate(workspace?.idealEndDate, 'DD-MMM-YYYY')}`} type='text' icon={<KoIcon name={'CalendarOutlined'} width={18} height={18} />} />
            </div>
            <div className={styles.projectFilter}>
              <KoAvatar isProfile={true} size={25} options={profile} maxCount={5} />
              {  isDashboardUrl === 'dashboard' &&  <KoDropdown
                placement="bottomRight"
                overlayClassName={'overlayClassName'}
                menu={{
                  items: dateRangeOptions,
                  onClick: getDashboardData
                }}
              >
                <div className={styles.dropdown}>
                  <KoText text={filter} />
                  <KoIcon name={'DownArrowOutlined'} width={12} height={12} />
                </div>
              </KoDropdown>}
              {isDashboardUrl === 'dashboard' ? (
                <div className={styles.sprintWrapper}>
                  <KoDropdown
                    icon={<KoIcon name="ActiveSprintOutlined" />}
                    placement="bottomRight"
                    menu={{
                      items: sprints?.map((spr) => ({
                        label: spr.name,
                        value: spr?.sprintId,
                        key: spr?.sprintId
                      })),
                      onClick: handleMenuClickIssue
                    }}
                  >
                    <div className={styles.dropdown}>
                      <KoText text= {shareSprint?.name
                        ? `${shareSprint?.name}`
                        : 'Select Sprint'} />
                      <KoIcon name={'DownArrowOutlined'} width={12} height={12} />
                    </div>
                  </KoDropdown>
                </div>
              ) : <div></div>}
              <KoButton onClick={() => setModalTicketCreate(true)} type='primary' icon={<KoIcon color='#FFF' name='PlusOutlined' />} label={`Create`} />

              <KoButton onClick={() => setModal(true)} type='primary' icon={<KoIcon color='#FFF' name='EditOutlined' />} label={`Workspace`} />

            </div>
          </div>
          <KoDescription text={workspace?.description} className={styles.description} />
        </div>
      </KoAffix>

      <Outlet context={[shareSprintId]} />

    </div>

    {isOpen && <WorkspaceCurd
      openSettings={isOpen}
      setOpenSettings={setModal}
      currentWorkspace={workspace}
      setCurrentRecord={() => { }}
    />}

    <KoModal
      title={`Create Issue`}
      centered
      afterClose={() => { form.resetFields();  }}
      open={isOpenTicketCreate}
      handleOk={() => { setModalTicketCreate(false); }}
      onClose={() => { setModalTicketCreate(false); form.resetFields(); }}
      width={'95vw'}
      maskClosable={false}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => { setModalTicketCreate(false); form.resetFields(); }} />,
        <KoButton key='create' loading={loading} type='primary' label={`Create`}
          onClick={() => {form.submit();setModalTicketCreate(false);}} />
      ]}
    >
      {loading && <KoLoader circle={false} />}
      < ITSupportCurd form={form} setLoading={setLoading} handleFinish={handleFinish} initialValues={{}} workspaceProfile={profile}  />
    </KoModal>
  </>;

}

export default HepldeskModule;